import _ from "lodash";
import moment from "moment";
import _s from 'underscore.string';
import StatusUtils from './StatusUtils';
import ConfigUtils from "./ConfigUtils";

export default class CommonUtils {
    static parseAudit = (audit, role?: string, type?: string, sourceTypes= null) => {
      let field = "";
      let row = _.clone(audit);

      if (row.field) {
          if((row.field).indexOf("dueDate") > -1) {
              row.newValue = moment(row.newValue).format('MM/DD/YY');
              row.oldValue = moment(row.oldValue).format('MM/DD/YY');
          }

          field = (row.field).substring(row.field.lastIndexOf("/")+1);

          field = _s(field).humanize().titleize().value();
      }

      if (!_.has(row,'newValue')) {
          row.newValue = null;
      }

      switch (row.action) {
          case 'Added':
              return "Added " + row.newValue + " to " + field;
          case 'Removed':
              return "Removed " + row.oldValue + " from " + field;
          case 'Changed Delivery':
          case 'Changed Sources':
          case 'Changed Contacts':
          case 'Changed Processes':
              return row.action;
          case 'Changed':

              if (field.toLowerCase() === 'status') {
                  row.oldValue = StatusUtils.maskStatus(row.oldValue, type, role);
                  row.newValue = StatusUtils.maskStatus(row.newValue, type, role);
                  if (row.oldValue === row.newValue) {
                      return undefined;
                  }
              }

              if (row.field === '/sourceType') {
                  const sourceLocationFields = ConfigUtils.getSourceLocations();
                  const newIdTypeOldValue = _.find(sourceLocationFields, ["value", row.oldValue]);
                  const newIdTypeNewValue = _.find(sourceLocationFields, ["value", row.newValue]);
                  const oldIdTypeOldValue = _.find(sourceTypes, ["value", row.oldValue]);
                  const oldIdTypeNewValue = _.find(sourceTypes, ["value", row.newValue]);
                  row.oldValue = _.get(newIdTypeOldValue, "label") ?? _.get(oldIdTypeOldValue, "label")
                  row.newValue = _.get(newIdTypeNewValue, "label") ?? _.get(oldIdTypeNewValue, "label")
                  if (row.oldValue === row.newValue) {
                      return undefined;
                  }
                  return "Changed Source Location" + (row.oldValue ? " from " + row.oldValue : "") + " to " + row.newValue;
              }

              return "Changed " + field + (row.oldValue ? " from " + row.oldValue : "") + " to " + row.newValue;
          case 'Created/Submitted':
          case 'New Job Submitted':
              return "New Job Submitted";
          case 'Mediapulse':
              return "Submitted to Mediapulse";
          case 'Automation':
              return "Automation Message - " + row.newValue;
          case 'Wrote':
              return "Added note: " + row.newValue + (row.notifyClient ? ' (--Client Notified--)': '');
          case 'Assigned':
              return row.newValue === null ? "Unassigned" : "Assigned " + row.newValue.fullName;
          case 'Retry':
              return (type === 'CONTENT_REQUEST_API' ? "Region re-requested CID " : "Retried delivery to ") + row.newValue;
          case 'Cancel':
              return "Cancelled delivery to " + row.newValue;
      }
    }
    static scrollToTarget = (target: HTMLElement) => {
        const findPosition = (obj) => {
          let currenttop = 0;
          if (obj.offsetParent) {
              do {
                  currenttop += obj.offsetTop;
              } while ((obj = obj.offsetParent));
              return currenttop;
          }
        }
        const yPosition = findPosition(target);
        // Substracting 260 as it is the space between the body top and table
        window.scroll({
            left: 0,
            top: yPosition - 260,
            behavior: 'smooth'
        });
    }
}
